import { bindActionCreators } from 'redux';
import React, { Component} from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import Tours from '../components/Tours';
import TourPreview from './tours/Preview';
import Header from './layout/Header';
import Map from './Map';
import * as toursActions from '../actions/tours';
import { Link } from 'react-router';
import * as TourActions from '../actions/tour';
import Sidebar from './layout/Sidebar';
import Helmet from "react-helmet";



class Hotel extends Component {

    componentWillMount() {


        this.props.toursActions.fetchHotel(this.props.params.param_id);
        this.props.toursActions.setMapConfig({
            active: false,
            fixed: true,
            type: 'ROADMAP'
        });


    }

    componentWillUpdate() {

    }




    componentWillUnmount() {

    }



    render () {
        const { hotel, seo } = this.props;

        let description = "";
        let re = /<[^>]+>/g;
        if (hotel.presentation) {
            description = (hotel.presentation) ? hotel.presentation.replace(re, '') : "";
            description = description.substr(0, 205);
            let lastSpace = description.lastIndexOf(" ");
            if (lastSpace > 0 && description.length > 200) {
                description = description.substr(0, lastSpace);
            }
        }

        let meta = [
            {"name": "description", "content": (seo.description)?seo.description:description}
        ];


        return (

            <section className="section section__page ">

                <Helmet
                    title={(seo.title)?seo.title:hotel.title}
                    meta={meta}
                />

                <Header />
                <div className="container page">
                    <div className="container__content">
                        <h1>{hotel.h1}</h1>
                        <div className="page__content">

                            <div dangerouslySetInnerHTML={{__html:hotel.presentation}}></div>
                            <div dangerouslySetInnerHTML={{__html:hotel.detailed}}></div>

                        </div>
                    </div>

                    <Sidebar />

                </div>
            </section>
        );
    }
}


Hotel.need = [
    {
        action: toursActions.fetchHotel
    }
];



function mapStateToProps(state) {

    return {
        hotel: state.tours.hotel,
        seo: state.user.seo
    };
}


function mapDispatchToProps(dispatch) {
    return {
        toursActions: bindActionCreators(toursActions, dispatch)
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(Hotel)





// WEBPACK FOOTER //
// ./src/common/components/Hotel.js